import { API_CALL } from '../../../../middleware/api';
import { actions as orgFilterActions } from '../../../../components/OrgSelect/orgFilterActions';

// Redux actions for the superuser "NPPES simulator" tab. Same conventions as
// ../AthenaSimulator/actions.js, except that only the routing endpoints
// (config, point-org, unpoint-org) carry the selected org: the simulated
// registry, the failure setting and the request log are global, because the
// real NPI Registry is one global public service.

const BASE = 'portal/dev/nppes-simulator';

export const GET_NPPES_SIM_CONFIG = 'GET_NPPES_SIM_CONFIG';
export const GET_NPPES_SIM_CONFIG_RESULT = `${GET_NPPES_SIM_CONFIG}/result`;
export const LIST_NPPES_SIM_PROVIDERS = 'LIST_NPPES_SIM_PROVIDERS';
export const LIST_NPPES_SIM_PROVIDERS_RESULT = `${LIST_NPPES_SIM_PROVIDERS}/result`;
export const GET_NPPES_SIM_COMM_LOG = 'GET_NPPES_SIM_COMM_LOG';
export const GET_NPPES_SIM_COMM_LOG_RESULT = `${GET_NPPES_SIM_COMM_LOG}/result`;
export const NPPES_SIM_WRITE = 'NPPES_SIM_WRITE';
export const NPPES_SIM_WRITE_RESULT = `${NPPES_SIM_WRITE}/result`;

const withOrg = (orgUUID, params) => (orgUUID ? { ...params, org_uuid: orgUUID } : params);

const get = (path, type, params) => ({
  [API_CALL]: { method: 'GET', endpoint: `${BASE}/${path}`, params },
  type,
});

// Every mutation shares one action type: the tab only needs to know whether it
// succeeded, and reloads afterwards.
const write = (method, path, body, params) => ({
  [API_CALL]: body === undefined
    ? { method, endpoint: `${BASE}/${path}`, params }
    : { method, endpoint: `${BASE}/${path}`, data: body },
  type: NPPES_SIM_WRITE,
});

export const actions = {
  getMyOrgs: orgFilterActions.getMyOrgs,
  getConfig: orgUUID => get('config', GET_NPPES_SIM_CONFIG, withOrg(orgUUID)),
  listProviders: () => get('providers', LIST_NPPES_SIM_PROVIDERS),
  getCommLog: () => get('communication', GET_NPPES_SIM_COMM_LOG, { limit: 500 }),
  pointOrg: orgUUID => write('PUT', 'point-org', withOrg(orgUUID, {})),
  unpointOrg: orgUUID => write('PUT', 'unpoint-org', undefined, withOrg(orgUUID)),
  setSettings: settings => write('PUT', 'settings', settings),
  addSampleData: () => write('POST', 'sample-data'),
  reset: () => write('POST', 'reset'),
  saveProvider: (id, provider) => (id
    ? write('PUT', `providers/${id}`, provider)
    : write('POST', 'providers', provider)),
  deleteProvider: id => write('DELETE', `providers/${id}`),
};
